import { trapFocus, removeTrapFocus } from '@theme/focus';

class LegacyDrawerMenu extends HTMLElement {
  connectedCallback() {
    this.drawerDetails = this.closest('header-drawer')?.querySelector('details');
    this.handleDrawerToggle = () => {
      if (!this.drawerDetails.open) this.resetSubmenus();
    };
    this.drawerDetails?.addEventListener('toggle', this.handleDrawerToggle);
    this.searchDialog = document.getElementById('search-modal');
    this.searchTrigger = this.querySelector('[data-legacy-drawer-search]');
    this.handleSearchClose = () => {
      if (!this.searchOpenedFromMenu) return;
      this.searchOpenedFromMenu = false;
      if (this.drawerDetails?.open) {
        trapFocus(this.drawerDetails);
        this.searchTrigger?.focus();
      }
    };
    this.handleSearchOpen = () => {
      if (!this.searchDialog) return;
      this.searchOpenedFromMenu = true;
      removeTrapFocus();
      this.searchDialog.showDialog();
    };
    this.searchTrigger?.addEventListener('click', this.handleSearchOpen);
    this.searchDialog?.addEventListener('dialog:close', this.handleSearchClose);
    this.querySelectorAll('[data-legacy-drawer-open]').forEach((button) =>
      button.addEventListener('click', () => this.openSubmenu(button.dataset.legacyDrawerOpen, button.textContent.trim()))
    );
    this.querySelectorAll('[data-legacy-drawer-back]').forEach((button) => button.addEventListener('click', () => this.closeSubmenu(button)));
  }

  disconnectedCallback() {
    this.drawerDetails?.removeEventListener('toggle', this.handleDrawerToggle);
    this.searchTrigger?.removeEventListener('click', this.handleSearchOpen);
    this.searchDialog?.removeEventListener('dialog:close', this.handleSearchClose);
  }

  openSubmenu(id, title) {
    const submenu = this.querySelector(`[data-legacy-drawer-submenu="${CSS.escape(id)}"]`);
    if (!submenu) return;
    submenu.classList.add('is-submenu-open');
    submenu.querySelector('[data-legacy-drawer-title]')?.replaceChildren(title);
  }

  closeSubmenu(button) {
    const submenu = button.closest('.c-main-menu__submenu');
    submenu?.classList.remove('is-submenu-open');
  }

  resetSubmenus() {
    this.querySelectorAll('.c-main-menu__submenu').forEach((submenu) => submenu.classList.remove('is-submenu-open'));
  }
}

if (!customElements.get('legacy-drawer-menu')) {
  customElements.define('legacy-drawer-menu', LegacyDrawerMenu);
}
